import { render } from "./SimpleEdit.vue?vue&type=template&id=0002ccef"
import script from "./SimpleEdit.vue?vue&type=script&lang=js"
export * from "./SimpleEdit.vue?vue&type=script&lang=js"
script.render = render

export default script